<template>
    <div class="recharge_left capital_first">
      <el-row class="headerTopBg">
        <el-col :span="12">
          <h3>
            {{$t('redEnvelope.heading')}}
            
            
          </h3>
        </el-col>
      </el-row>
      <el-row class="headerTopBg">
        <div class="values-bar">
                  <el-row style="display: flex; align-items: center">
                    <el-col :span="4" class="capital">
                      <!-- <h5>{{$t('redEnvelope.redeemableAmount')}}</h5> -->
                      <h5>{{$t('redEnvelope.amoun')}}</h5>
                      <p>
                        <!-- <span class="integer-value">{{ red_env_cash }}</span> -->
                        <span class="integer-value">{{ red_env_cash  }}</span>
                        <span class="decimal-value">元</span>
                      </p>
                    </el-col>
                    <el-col :span="4" class="capital">
                      <!-- <h5>{{ $t('redEnvelope.totalAmountRedeemed') }}</h5> -->
                      <h5>{{$t('redEnvelope.redeemablePurchaseAmount')}}</h5>
                      <p>
                        <!-- <span class="integer-value">{{ red_env_trade_total }}</span> -->
                        <span class="integer-value">{{red_env_trade_total   }}</span>
                        <span class="decimal-value">元</span>
                      </p>
                    </el-col>
                    <el-col :span="4" class="capital">
                      <!-- <h5>{{$t('redEnvelope.redeemablePurchaseAmount')}}</h5> -->
                      <h5>{{$t('redEnvelope.redeemableAmount')}}</h5>
                      <p>
                        <!-- <span class="integer-value">{{ available_red_env_amount }}</span> -->
                        <span class="integer-value">{{ available_red_env_amount }}</span>
                        <span class="decimal-value">元</span>
                      </p>
                    </el-col>
                    <el-col :span="4" class="capital">
                      <!-- <h5>{{$t('redEnvelope.amoun')}}</h5> -->
                      <h5>{{ $t('redEnvelope.totalAmountRedeemed') }}</h5>
                      <p>
                        <!-- <span class="integer-value">{{ withdraw_red_env_cash }}</span> -->
                        <span class="integer-value">{{ withdraw_red_env_cash  }}</span>
                        <span class="decimal-value">元</span>
                      </p>
                    </el-col>
                    <el-col :span="4" class="capital">
                      <!-- <h5>{{$t('redEnvelope.amoun')}}</h5> -->
                      <h5>{{ $t('redEnvelope.pendingWithdrawAmount') }}</h5>
                      <p>
                        <!-- <span class="integer-value">{{ withdraw_red_env_cash }}</span> -->
                        <span class="integer-value">{{ pending_withdraw_amount  }}</span>
                        <span class="decimal-value">元</span>
                      </p>
                    </el-col>
                    <el-col
                      :span="4"
                      style="text-align: right; padding-right: 20px"
                    >
                      <el-button
                        @click="
                          withdrawState = true;
                        "
                        class="btn-white-bg"
                        size="small"
                        >兑现</el-button
                      >
                    </el-col>
                  </el-row>
                </div>
        <el-tabs id="timeBaoTabs">
          <el-tab-pane id="Giveaway_red_envelopes">
            <h4 slot="label">{{ $t('redEnvelope.RedEnvelopes') }}</h4>
            <el-card>
              
              <el-table
                :data="all_logs.data"
                size="mini"
                stripe
                style="width: 100%"
              >
                <el-table-column prop="order" align="center" :label="$t('redEnvelope.number')">
                </el-table-column>
                <el-table-column prop="type" align="center" :label="$t('redEnvelope.type')">
                    <template slot-scope="scope"> 
                      <span v-if="scope.row.type == '0'">{{$t('redEnvelope.approve')}}</span>
                      <span v-if="scope.row.type == '1'">{{$t('redEnvelope.withdraw')}}</span>
                      <span v-if="scope.row.type == '2'">{{$t('redEnvelope.register')}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="red_envelop_cash_amount" align="center" :label="$t('redEnvelope.cashAmount')">
                </el-table-column>
                <el-table-column prop="red_envelop_cash_balance" align="center" :label="$t('redEnvelope.amoun')">
                </el-table-column>
                <el-table-column prop="cash_wit_total" align="center" :label="$t('redEnvelope.totalRedeemedAmount')">
                </el-table-column>
                <el-table-column prop="create_time" align="center" :label="$t('redEnvelope.RedEnvelopeDate')">
                </el-table-column>
              </el-table>
              <div class="changePage" style="padding-top: 15px; display: flex; align-items: center; justify-content: space-between;">
                <el-button
                  type="primary"
                  icon="el-icon-arrow-left"
                  @click="prevTimebao(1)"
                  size="mini"
                  style="background: var(--baseColor); border-color: var(--baseColor);"
                >
                  {{ $t('timeBao.previous') }}
                </el-button>

                <div style="padding: 0 10px; font-size: 10px;">
                  {{page}} / {{all_pages}}
                </div>

                <el-button
                  type="primary"
                  @click="nextTimebao(1)"
                  size="mini"
                  style="background: var(--baseColor); border-color: var(--baseColor);"
                >
                  {{ $t('timeBao.next') }}
                  <i class="el-icon-arrow-right"></i>
                </el-button>
              </div>
            </el-card>
          </el-tab-pane>
          <!-- <el-tab-pane id="Giveaway_red_envelopes">
            <h4 slot="label">{{ $t('redEnvelope.giveAwayRedEnvelopes') }}</h4>
            <el-card>
              
              <el-table
                :data="recharge_logs.data"
                size="mini"
                stripe
                style="width: 100%"
              >
                <el-table-column prop="order" align="center" :label="$t('redEnvelope.number')">
                </el-table-column>
                <el-table-column prop="red_envelop_cash_amount" align="center" :label="$t('redEnvelope.amount')">
                </el-table-column>
                <el-table-column prop="red_envelop_cash_balance" align="center" :label="$t('redEnvelope.amoun')">
                </el-table-column>
                <el-table-column prop="create_time" align="center" :label="$t('redEnvelope.giftDate')">
                </el-table-column>
              </el-table>
              <div class="changePage" style="padding-top: 15px" >
                <el-button
                  type="primary"
                  icon="el-icon-arrow-left"
                  @click="prevTimebao(1)"
                  size="mini"
                  style="background: var(--baseColor); border-color: var(--baseColor);"
                  >{{ $t('timeBao.previous') }}</el-button
                >
                <el-button v-if="recharge_logs.data.length>=20"
                  type="primary"
                  @click="nextTimebao(1)"
                  size="mini"
                  style="float: right; background: var(--baseColor); border-color: var(--baseColor);"
                >
                {{ $t('timeBao.next') }}
                <i class="el-icon-arrow-right"></i>
                </el-button>
              </div>
            </el-card>
          </el-tab-pane> -->
          <!-- <el-tab-pane id="cash_history">
            <h4 slot="label">{{$t('redEnvelope.cashHistory')}}</h4>
            <el-card>
              
              <el-table
                :data="withdraw_logs.data"
                size="mini"
                stripe
                style="width: 100%"
              >
                <el-table-column prop="order" align="center" :label="$t('redEnvelope.redemptionNumber')">
                </el-table-column>
                <el-table-column prop="red_envelop_cash_amount" align="center" :label="$t('redEnvelope.redeemAmount')">
                </el-table-column>
                <el-table-column prop="red_envelop_cash_balance" align="center" :label="$t('redEnvelope.amoun')">
                </el-table-column>
                <el-table-column prop="cash_wit_total" align="center" :label="$t('redEnvelope.totalRedeemedAmount')">
                </el-table-column>
                <el-table-column prop="create_time" align="center" :label="$t('redEnvelope.redeemDate')">
                </el-table-column>
              </el-table>
              <div class="changePage" style="padding-top: 15px" >
                <el-button
                  type="primary"
                  icon="el-icon-arrow-left"
                  @click="prevTimebao(2)"
                  size="mini"
                  style="background: var(--baseColor); border-color: var(--baseColor);"
                  >{{ $t('timeBao.previous') }}</el-button
                >
                <el-button v-if="withdraw_logs.data.length>=20"
                  type="primary"
                  @click="nextTimebao(2)"
                  size="mini"
                  style="float: right; background: var(--baseColor); border-color: var(--baseColor);"
                >
                {{ $t('timeBao.next') }}
                <i class="el-icon-arrow-right"></i>
                </el-button>
              </div>
            </el-card>
          </el-tab-pane> -->
          <el-tab-pane id="buying_history">
            <h4 slot="label">{{$t('redEnvelope.buyingHistory')}}</h4>
            <el-card>
             
              <el-table
                :data="deal_logs.data"
                size="mini"
                stripe
                style="width: 100%"
              >
                <el-table-column prop="order" align="center" :label="$t('redEnvelope.transactionNumber')">
                </el-table-column>
                <el-table-column  align="center" :label="$t('redEnvelope.stockName')">
                  <template slot-scope="scope">
                    <p
                       
                    >
                      {{ scope.row.name  }}<br>{{ scope.row.code }}
                    </p>
                  </template>
                </el-table-column>
                <el-table-column prop="deal" align="center" :label="$t('redEnvelope.buyingPrice')">
                </el-table-column>
                <el-table-column prop="number" align="center" :label="$t('redEnvelope.buyingQuantity')">
                </el-table-column>
                <el-table-column prop="total_amount" align="center" :label="$t('redEnvelope.buyingAmount')">
                </el-table-column>
                <!-- <el-table-column prop="time" align="center" :label="$t('redEnvelope.redeemablePurchaseAmount')">
                </el-table-column> -->
                <el-table-column prop="create_time" align="center" :label="$t('redEnvelope.buyingTime')">
                </el-table-column>
              </el-table>
              <div class="changePage" style="padding-top: 15px; display: flex; align-items: center; justify-content: space-between;">
                <el-button
                  type="primary"
                  icon="el-icon-arrow-left"
                  @click="prevTimebao(3)"
                  size="mini"
                  style="background: var(--baseColor); border-color: var(--baseColor);"
                >
                  {{ $t('timeBao.previous') }}
                </el-button>

                <div style="padding: 0 10px; font-size: 10px;">
                  {{page2}} / {{all_pages1}}
                </div>

                <el-button
                  type="primary"
                  @click="nextTimebao(3)"
                  size="mini"
                  style="background: var(--baseColor); border-color: var(--baseColor);"
                >
                  {{ $t('timeBao.next') }}
                  <i class="el-icon-arrow-right"></i>
                </el-button>
              </div>
            </el-card>
          </el-tab-pane>
          <!-- <el-tab-pane id="giveaway_cash">
            <h4 slot="label">{{$t('redEnvelope.giveAwayCash')}}</h4>
            <el-card>
              <el-table
                :data="timebaoDetails.data"
                size="mini"
                stripe
                style="width: 100%"
              >
                <el-table-column prop="name" align="center" :label="$t('redEnvelope.sendCashNumber')">
                </el-table-column>
                <el-table-column prop="amount" align="center" :label="$t('redEnvelope.cashAmount')">
                </el-table-column>
                <el-table-column prop="balance" align="center" :label="$t('redEnvelope.deductPurchaseAmount')">
                </el-table-column>
                <el-table-column prop="time" align="center" :label="$t('redEnvelope.redeemablePurchaseAmount')">
                </el-table-column>
                <el-table-column prop="time" align="center" :label="$t('redEnvelope.amountRedeemed')">
                </el-table-column>
                <el-table-column prop="time" align="center" :label="$t('redEnvelope.time')">
                </el-table-column>
              </el-table>
              <div class="changePage" style="padding-top: 15px">
                <el-button
                  type="primary"
                  icon="el-icon-arrow-left"
                  @click="prevTimebao"
                  size="mini"
                  style="background: var(--baseColor); border-color: var(--baseColor);"
                  >{{ $t('timeBao.previous') }}</el-button
                >
                <el-button
                  type="primary"
                  @click="nextTimebao"
                  size="mini"
                  style="float: right; background: var(--baseColor); border-color: var(--baseColor);"
                >
                {{ $t('timeBao.next') }}
                <i class="el-icon-arrow-right"></i>
                </el-button>
              </div>
            </el-card>
          </el-tab-pane> -->
        </el-tabs>
      </el-row>
      <el-dialog
        class="red_env"
        :title="$t('redEnvelope.redeemTransaction')"
        :visible.sync="withdrawState"
      >
        <el-form ref="form" label-width="120px" size="small">
          <el-form-item>
            <h4 slot="label">{{$t('redEnvelope.availableAmount')}}</h4>
            <p>{{ available_red_env_amount }}{{$t('recharge.yuan')}}</p>
          </el-form-item>
          <el-form-item id="inputField">
            <h4 slot="label">{{$t('redEnvelope.transactionAmount')}}</h4>
            <el-input
              oninput="value=value.replace(/[^\d.]/g,'')"
              v-model="withdrawAmount"
              placeholder=""
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="withdrawState = false" class="dialog-cancel">{{$t('account.cancel')}}</el-button>
          <el-button type="primary" @click="withdraw" style="background-color: #ee5c35;border-color:#ee5c35">{{$t('trading.sure')}}</el-button>
        </div>
      </el-dialog>
  
     
    </div>
  </template>
  
  <script>
      import { Loading } from 'element-ui';
      export default {
          name: "timebao",
        data(){
          return{
            cash:0,
            withdrawAmount:"",
            withdrawState:false,
          all_logs: {
            data: [],
            num: 20
          },
          recharge_logs: {
            data: [],
            num: 20
          },
          page:1,
          withdraw_logs: {
            data: [],
            num: 20
          },
          page1:1,
          deal_logs: {
            data: [],
            num: 20
          },
          page2:1,
          red_env_cash:0,
				withdraw_red_env_cash:0,
				red_env_trade_total:0,
				available_red_env_amount:0,
        pending_withdraw_amount:0,
        all_pages:1,
        all_pages1:1,
          }
        },
        computed:{
        },
        methods: {
          getRedenvInfo(){
            let that = this;
              that
              .$http({
                  url: "/app/RedEnvelopeManagement/red_envelop_info",
                  method: "post",
              })
              .then(function (res) {
                  if (res.data.status == 200) {
                    that.red_env_cash = res.data.data[0]['red_envelop_cash'];
					that.withdraw_red_env_cash = res.data.data[0]['withdraw_red_envelop_cash'];
					that.red_env_trade_total = res.data.data[0]['red_envelop_trade_total'];
					that.available_red_env_amount = res.data.data[0]['available_wit_amount']; 
          that.pending_withdraw_amount = res.data.data[0]['pending_withdraw_amount'];                 
        } else  {
                  that.$message.error(that.$t(res.data.msgId));
                  }
              });
          },
          getRedenvAllLogs() {
              let that = this;
              console.log(that.all_logs.page);

              that
              .$http({
                  url: "/app/RedEnvelopeManagement/all_log",
                  method: "post",
                  data: {
                page:that.page,
                num:20
                  },
              })
              .then(function (res) {
                  if (res.data.status == 200) {
                    that.all_logs=res.data;
                    that.all_pages = Math.ceil((res.data.code)/20);
                    console.log(that.all_logs.data.length);
                  } else  {
                  that.$message.error(that.$t(res.data.msgId));
                  }
              });
        },
         getRedenvRechargeLogs() {
              let that = this;
              console.log(that.recharge_logs.page);

              that
              .$http({
                  url: "/app/RedEnvelopeManagement/recharge_log",
                  method: "post",
                  data: {
                page:that.page,
                num:20
                  },
              })
              .then(function (res) {
                  if (res.data.status == 200) {
                    that.recharge_logs=res.data;
                    console.log(that.recharge_logs.data.length);
                  } else  {
                  that.$message.error(that.$t(res.data.msgId));
                  }
              });
        },
        getRedenvWithdrawLogs() {
              let that = this;
              that
              .$http({
                  url: "/app/RedEnvelopeManagement/withdraw_log",
                  method: "post",
                  data: {
                page:that.page1,
                num:20
                  },
              })
              .then(function (res) {
                  if (res.data.status == 200) {
                    that.withdraw_logs=res.data;
                  } else  {
                  that.$message.error(that.$t(res.data.msgId));
                  }
              });
        },
        getRedenvDealLogs() {
              let that = this;
              that
              .$http({
                  url: "/app/RedEnvelopeManagement/deal_log",
                  method: "post",
                  data: {
                page:that.page2,
                num:20
                  },
              })
              .then(function (res) {
                  if (res.data.status == 200) {
                    that.deal_logs=res.data;
                    that.all_pages1 = Math.ceil((res.data.code)/20);
                  } else  {
                  that.$message.error(that.$t(res.data.msgId));
                  }
              });
        },
        nextTimebao(currentTab){
          if(currentTab==1){
            if ( this.page == this.all_pages){
              this.$message({
                message: this.$t('timeBao.alreadyLastPage'),
                type: 'warning'
              });
            }else{
              this.page++;
              this.getRedenvAllLogs();
            }
          }
      
          else if(currentTab==3){
            if ( this.page2 == this.all_pages1){
              this.$message({
                message: this.$t('timeBao.alreadyLastPage'),
                type: 'warning'
              });
            }else{
              this.page2++;
              this.getRedenvDealLogs();
            }
          }
            
            
          },
     
        prevTimebao(currentTab){
          if(currentTab==1){
            let page = this.page;
            if (page == 1){
              this.$message({
                message: this.$t('timeBao.alreadyFirstPage'),
                type: 'warning'
              });
            }else{
              this.page--;
              this.getRedenvAllLogs();
            }
          }
      
          else if(currentTab==3){
            let page = this.page2;
            if (page == 1){
              this.$message({
                message: this.$t('timeBao.alreadyFirstPage'),
                type: 'warning'
              });
            }else{
              this.page2--;
              this.getRedenvDealLogs();
            }
          }
          },

      withdraw(){
          let that = this;
          let money = that.withdrawAmount;
          if (money == "" || money <= 0 || isNaN(money)) {
            that.$message.error(that.$t('redEnvelope.emptyAmount'));
        return false;
      }else if (money % 100 != 0) {
            that.$message.error(that.$t('redEnvelope.amountShouldBeHundredTimes'));
        return false;
      }
      else{
              that
                .$http({
                  url: "/app/RedEnvelopeManagement/withdraw_redeem",
                  method: "post",
                  data: {
                    withdrawAmount: money,
                  },
                })
                
                .then(function (res) {
                  if (res.data.status == 200) {
                    that.withdrawState = false;
                    that.$message({
                      message: that.$t(res.data.msgId),
                      type: 'success',
                      onClose:function () {
                      },
                    });
                    that.withdrawAmount="",
                    that.getRedenvInfo();
                    that.getRedenvWithdrawLogs();
                  } else {
                    that.$message.error(that.$t(res.data.msgId));
                  }
                });
              }
            
        },
    
       
        },
       
        mounted () {
          this.getRedenvAllLogs();
          // this.getRedenvRechargeLogs();
          // this.getRedenvWithdrawLogs();
          this.getRedenvDealLogs();
          this.getRedenvInfo();
        },
        beforeDestroy() {
          
        },
      }
  </script>
  
  <style scoped>
  .headerTopBg {
    background-color: #ffffff;
    border-radius: 8px;
    margin-bottom: 20px;
    padding: 18px 20px;
  }
  
  .headerDetail {
    font-weight: normal;
    font-size: 14px;
    color: #f46f83;
  }
  
  .capital {
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  
  .capital p {
    font-size: 20px;
  }
  
  .capital h5 {
    font-size: 14px;
    font-weight: 300;
  }
  .box-card {
    border-radius: 15px;
    border: none;
  }
  .box-card>>>.el-card__header {
    background-color: #FFFFFF;
    border-radius: 15px;
    border: none;
  }
  .box-card>>>.el-card__body {
    background-color: #FFFFFF;
    border-radius: 15px;
    border: none;
  }
  .values-bar {
    background-color: var(--baseColor);
    border-radius: 10px;
    color: #FFFFFF;
    padding: 12px 10px;
    margin-bottom:20px;
  }
  .btn-white-bg {
    background-color: #FFFFFF;
    color: var(--baseColor);
    border-radius: 5px;
    padding: 14px 27px;
    font-size: 15px;
  }
  
  .btn-white-bg:hover,
  .btn-blue-bg:hover {
    background-color: #FFFFFF !important;
    color: #ee5c35 !important;
  }
  
  .btn-blue-bg {
    background-color: var(--baseColor);
    color: #FFFFFF;
    border: 2px solid #FFFFFF;
    border-radius: 10px;
    padding: 14px 27px;
    font-size: 15px;
  }
  .integer-value {
    font-size: 24px;
    font-weight: 500;
  }
  .decimal-value {
    font-size: 17px;
    font-weight: 500;
    margin-left: -5px;
  }
  #inputField>>>.el-input__inner:focus {
    border-color: var(--baseColor) !important;
  }
  
  .dialog-cancel:hover {
    color: var(--baseColor) !important;
    border-color: var(--baseColor) !important;
    background-color: #fff !important;
    border-color: var(--baseColor) !important;
  }
  #inputField>>>.el-input__inner:hover {
    border-color: var(--baseColor) !important;
  }
  #inputField>>>.el-input__inner:active {
    border-color: var(--baseColor) !important;
  }
  #inputField>>>.el-range-editor.is-active {
    border-color: var(--baseColor) !important;
  }
  </style>
  
  <style>
  .red_env .el-dialog {
    width: 25% !important;
    margin-top:330px !important;
  }
  #timeBaoTabs .el-tabs__active-bar {
    display: none;
    background-color: var(--baseColor);
  }
  
  #timeBaoTabs .el-tabs__item.is-active {
    color: var(--baseColor) !important;
  }
  #timeBaoTabs .el-tabs__item:hover {
    color: var(--baseColor) !important;
  }
  
  #timeBaoTabs .el-tabs__item.is-active:after {
    height: 4px;
    display: block;
    width: auto;
    background: var(--baseColor) !important;
    content: "";
    border-radius: 5px;
    width: 45px;
    display: block;
    margin: 0 auto;
    top: -4px;
    position: relative;
  }
  .el-date-table td.today span {
    color: var(--baseColor) !important;
  }
  .el-date-table td.end-date span, .el-date-table td.start-date span {
    background-color: var(--baseColor) !important;
    color: #fff !important;
  }
  </style>


// WEBPACK FOOTER //
// src/components/redEnvelope.vue